import * as Yup from 'yup';
/* eslint-disable import/no-extraneous-dependencies */
import { t } from 'src/lib/language';
import { idField, idFieldRequired } from 'src/lib/ValidatorHelper';

const InvoiceValidator = (lang:string) => Yup.object().shape({
  contact_id: idFieldRequired()
    .required(t(lang, 'validations.invoice.field_required')),
  department_id: idFieldRequired()
    .required(t(lang, 'validations.invoice.field_required')),
  account_id: idFieldRequired()
    .required(t(lang, 'validations.invoice.field_required')),
  program_id: idFieldRequired()
    .required(t(lang, 'validations.invoice.field_required')),
  bank_account_id: idFieldRequired()
    .required(t(lang, 'validations.invoice.field_required')),
  issued_date: Yup.date()
    .required('This field is required'),
  due_date: Yup.date()
    .required('This field is required'),
  title: Yup.string()
    .max(150, t(lang, 'validations.invoice.field_maximum', { max: 150 }))
    .required(),
  billing_address: Yup.string()
    .max(250, t(lang, 'validations.invoice.field_maximum', { max: 250 }))
    .nullable(),
  billing_suite: Yup.string()
    .max(150, t(lang, 'validations.invoice.field_maximum', { max: 150 }))
    .nullable(),
  billing_city: Yup.string()
    .max(150, t(lang, 'validations.invoice.field_maximum', { max: 150 }))
    .nullable(),
  billing_state: Yup.string()
    .max(150, t(lang, 'validations.invoice.field_maximum', { max: 150 }))
    .nullable(),
  billing_country_id: idField()
    .nullable()
    .notRequired(),
  billing_zip_code: Yup.string()
    .max(7, t(lang, 'validations.invoices.field_maximum', { max: 7 }))
    .nullable(),
  shipping_address: Yup.string()
    .max(250, t(lang, 'validations.invoices.field_maximum', { max: 250 }))
    .nullable(),
  shipping_suite: Yup.string()
    .max(150, t(lang, 'validations.invoices.field_maximum', { max: 150 }))
    .nullable(),
  shipping_city: Yup.string()
    .max(150, t(lang, 'validations.invoices.field_maximum', { max: 150 }))
    .nullable(),
  shipping_state: Yup.string()
    .max(150, t(lang, 'validations.invoices.field_maximum', { max: 150 }))
    .nullable(),
  shipping_country_id: idField()
    .nullable()
    .notRequired(),
  shipping_zip_code: Yup.string()
    .max(7, t(lang, 'validations.invoices.field_maximum', { max: 7 }))
    .nullable(),
});

export default InvoiceValidator;
